import styled from 'styled-components';
import { Box } from 'grommet/es6/components/Box';

// eslint-disable-next-line import/prefer-default-export

export var StyledCard = styled(Box).withConfig({
  displayName: 'StyledCard',
  componentId: 'sc-1cfdley-0'
})(['@media (max-width:', 'px){flex-basis:100%;}'], function (props) {
  return props.theme.global.breakpoints.small;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-controls/es6/components/Card/StyledCard.js
// module id = 1130
// module chunks = 0